import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TMechanicDashboardState } from './mechanic-status-dashboard.models';

export const getMechanicDashboardState = (state: TMachineMaintenanceState) => state.mechanicDashboardInfo;

export const getMechanicDashboardInfo = createSelector(
  getMechanicDashboardState,
  (state: TMechanicDashboardState) => state.mechanicDashboardInfo,
);
